var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9733_3050)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6668 2.00033H13.3335C14.0668 2.00033 14.6668 2.60033 14.6668 3.33366V14.0003C14.6668 14.7337 14.0668 15.3337 13.3335 15.3337H2.66683C1.9335 15.3337 1.3335 14.7337 1.3335 14.0003V3.33366C1.3335 2.60033 1.9335 2.00033 2.66683 2.00033H3.3335V0.666992H4.66683V2.00033H11.3335V0.666992H12.6668V2.00033ZM2.66683 14.0003H13.3335V5.33366H2.66683V14.0003ZM12.0002 6.667H4.00015V8.00034H12.0002V6.667Z",
    fill: "#8E97AA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9733_3050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2195bb984f04b98066d69b24c5c337f1.svg";
export { ForwardRef as ReactComponent };